import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/** トップページ最上部のキャッチコピーとリード文を表示する */
const HeroSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h2"
          component="h1"
          align="center"
          sx={{
            fontWeight: 700,
            fontSize: { xs: '7.5vw', sm: '2.4rem', md: '3rem' },
            lineHeight: 1.3,
            color: 'primary.main',
            mb: 4,
          }}
        >
          {t('hero.catch')}
        </Typography>
        <Typography
          align="left"
          sx={{
            fontSize: { xs: '1rem', md: '1.15rem' },
            lineHeight: 1.9,
          }}
        >
          {t('hero.lead1')}
          <br />
          {t('hero.lead2')}
        </Typography>
      </Container>
    </Box>
  );
};

export default HeroSection;
